import React, { useContext } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { AuthContext } from '../context/auth';

function AuthRoute({ component: Component, ...rest }) {
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? (
          <Redirect strict from={pathname} to="/dashboard" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

export default AuthRoute;
